var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.cardClass,style:({left:_vm.x - 3*_vm.w/4 + 'px', top:_vm.y + 'px', width:_vm.w - _vm.marginX + 'px', height:_vm.h - _vm.marginY + 'px'}),on:{"mousedown":_vm.onCardDown,"mousemove":_vm.onCardMove,"mouseup":_vm.onCardUp}},[_c('span',[_vm._v(_vm._s(this.msg))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee35c34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tree/graph/SubBoardCard.vue
// module id = null
// module chunks = 